<h3 *ngIf="config?.title" class="tw-mb-3 tw-mr-1 tw-text-center">
  {{ config?.title }}
</h3>

<div
  class="x-visible tw-relative tw-my-4"
  [class]="config.showTableShadow ? 'dynamic-table-shadow' : ''"
>
  <!-- دکمه های اسکرول توی هدر جدول -->
  @if(isShowScrollBtns()){

  <!-- دکمه اسکرول به راست -->
  <div
    class="tw-absolute ltr:tw-order-2 tw-right-0 tw-mx-2 tw-bg-gray-400 dark:tw-bg-gray-600 tw-z-40 tw-opacity-50 hover:tw-opacity-80 tw-rounded-full tw-shadow-md tw-h-8 tw-w-8 tw-flex-center tw-cursor-pointer"
    [style.top]="rowHeight - 10 + 'px'"
    (mousedown)="startScrollRight()"
    (mouseup)="stopScroll()"
    (mouseleave)="stopScroll()"
    (click)="scrollRight()"
  >
    <i
      class="mdi mdi-22px !tw-text-gray-200"
      [ngClass]="appState.isLtr() ? 'mdi-chevron-left' : 'mdi-chevron-right'"
    ></i>
  </div>

  <!-- دکمه اسکرول به چپ -->
  <div
    (mousedown)="startScrollLeft()"
    (mouseup)="stopScroll()"
    (mouseleave)="stopScroll()"
    (click)="scrollLeft()"
    [style.top]="rowHeight - 10 + 'px'"
    class="tw-absolute tw-left-0 tw-mx-2 tw-bg-gray-400 dark:tw-bg-gray-600 tw-z-40 tw-opacity-50 hover:tw-opacity-80 tw-rounded-full tw-shadow-md tw-h-8 tw-w-8 tw-flex-center tw-cursor-pointer"
  >
    <i
      class="mdi mdi-22px !tw-text-gray-200"
      [ngClass]="appState.isLtr() ? 'mdi-chevron-right' : 'mdi-chevron-left'"
    ></i>
  </div>
  }

  <div
    stickyPosition
    [applyStickyPosition]="applyCustomization"
    [pageName]="config?.pageTagName"
    [loading]="input_loading"
    [stickyCondition]="
      config?.isSticky &&
      !input_isEmpty &&
      !appIntroService.visible() &&
      !input_loading
    "
    class="dynamic-table tw-table-auto tw-w-full tw-overflow-x-auto"
    #table
    #scroller
    [ngClass]="config?.hasTableResponsive ? 'table-responsive' : ''"
    (scroll)="TableScroll()"
  >
    <div [class.fixed-height]="config.isFixedHeight">
      <table
        sortColumns
        [applySortColumns]="applyCustomization"
        [loading]="input_loading"
        [pageName]="config?.pageTagName"
        class="table table-head-custom table-vertical-center !tw-mb-0"
      >
        <!-- head -->
        <thead>
          <!-- columns  -->
          <tr #tableRow class="tw-relative">
            <th
              [ngClass]="{
                'sticky-item':
                  config?.isSticky &&
                  !input_loading &&
                  !input_isEmpty &&
                  applyCustomization
              }"
              class="lg:!tw-bg-[#f2f6f7] lg:dark:!tw-bg-[#29293d]"
              [attr.position]="'right'"
            >
              <div
                class="tw-px-2"
                [ngClass]="{
                  'tw-flex-between ':
                    queryString != '' && config?.showDeleteFilters
                }"
              >
                <i
                  [matTooltip]="'common.deleteFilters' | translate"
                  *ngIf="queryString != '' && config?.showDeleteFilters"
                  (click)="clearQueryString()"
                  class="mdi mdi-filter-remove-outline tw-text-red-500 tw-text-[26px]"
                ></i>

                <i
                  *ngIf="applyCustomization"
                  [matMenuTriggerFor]="menu"
                  class="mdi mdi-cog tw-text-primary-500 hover:tw-text-primary-400 dark:!tw-text-primary-200 hover:dark:!tw-text-primary-300 tw-cursor-pointer tw-text-[26px]"
                ></i>

                <mat-menu #menu="matMenu">
                  <button
                    mat-menu-item
                    (click)="openTableColumnSettingsDialog()"
                  >
                    <span>{{ "common.tableSetting" | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="resetTableSettings()">
                    <span>{{ "common.reset" | translate }}</span>
                  </button>
                </mat-menu>
              </div>
            </th>
            @for(col of config?.tableColumns; track $index; let last=$last){
            <!--#region select All CheckBox-->
            <th
              [attr.index]="$index + 1"
              *ngIf="col?.isCheckBox"
              [ngClass]="{
                'tw-px-[1px]': col?.wrap,
                'sticky-item lg:!tw-border-l-0':
                  col?.isSticky &&
                  !input_loading &&
                  !input_isEmpty &&
                  applyCustomization
              }"
              class="lg:!tw-bg-[#f2f6f7] lg:dark:!tw-bg-[#29293d]"
              [setPositionByIndex]="$index"
            >
              <div
                class="tw-flex tw-justify-center tw-items-center"
                style="position: relative; top: 2px"
              >
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input select-all"
                    style="margin-right: initial !important"
                    (click)="emitSelectAll($event)"
                  />
                </div>
              </div>
            </th>
            <th
              [attr.index]="$index + 1"
              [style.width]="
                innerWidth > 1024 && !col.disableResize && applyCustomization
                  ? col?.size + 'px'
                  : null
              "
              resizeColumn
              [applyResizeColumn]="applyCustomization"
              [size]="
                !col.disableResize && applyCustomization ? col?.size : null
              "
              [loading]="input_loading"
              (columnSize)="setColumnSize($event, col)"
              [pageName]="config?.pageTagName"
              [stickyPositionDirective]="stickyPositionDirective"
              *ngIf="!col?.isCheckBox"
              [attr.colspan]="col?.colSpan || 1"
              [ngClass]="{
                'tw-px-[1px]': col?.wrap,
                'sticky-item lg:!tw-border-l-0 lg:hover:tw-z-[2]':
                  col?.isSticky &&
                  !input_loading &&
                  !input_isEmpty &&
                  applyCustomization,
                'tw-hidden':
                  col?.isHide && innerWidth > 1024 && applyCustomization
              }"
              class="tw-group tw-relative"
              [setPositionByIndex]="$index"
              [attr.name]="col?.name"
              [attr.order]="col?.isSticky && !col?.order ? null : col?.order"
              [attr.sticky]="col?.isSticky"
            >
              <div
                *ngIf="
                  !last &&
                  !input_loading &&
                  !input_isEmpty &&
                  applyCustomization &&
                  !col.disableResize
                "
                class="resize-column-btn tw-absolute tw-hidden group-hover:lg:tw-block tw-left-[-7px] tw-top-0 tw-bottom-0 tw-z-[1] tw-cursor-col-resize tw-bg-blue-200/80 dark:tw-bg-blue-900 tw-rounded-md"
              >
                <i
                  class="mdi mdi-20px mdi-equal tw-rotate-90 tw-text-primary-600 dark:!tw-text-gray-300 tw-w-[14px] tw-h-full tw-flex-center"
                ></i>
              </div>

              <div
                [style.width]="
                  innerWidth > 1024 && !col.disableResize && applyCustomization
                    ? col?.size + 'px'
                    : null
                "
                class="tw-flex tw-justify-center tw-items-center resize-column hover:tw-z-[1] tw-overflow-hidden"
                [ngClass]="{
                  'flex-column': col?.wrap,
                  'tw-flex tw-justify-between tw-items-center': !col?.wrap
                }"
              >
                <!--#region col title -->
                <div
                  class="tw-my-[3px] tw-whitespace-nowrap tw-overflow-x-hidden"
                >
                  <span class="tw-font-bold tw-text-sm tw-whitespace-nowrap">
                    {{ col?.title | translate }}
                  </span>
                  <small
                    class="tw-font-bold tw-text-xs"
                    *ngIf="col?.needCurrency"
                  >
                    {{ "common.currencyWithParentheses" | translate }}
                  </small>
                </div>
                <!--#endregion -->

                <div
                  class="tw-flex flex-grow-1 tw-my-[3px]"
                  [ngClass]="{
                    'tw-justify-center tw-items-center': col?.wrap,
                    'tw-justify-between tw-items-center': !col?.wrap
                  }"
                >
                  <!--#region field-sorter -->
                  <app-field-sorter
                    [clearFilters]="clearFilters"
                    [title]="col?.title"
                    [name]="col?.name"
                    [needCurrency]="col?.needCurrency"
                    [noSorting]="col?.noSorting"
                    (sortItem)="getSortItems($event)"
                  ></app-field-sorter>
                  <!--#endregion -->

                  <!--#region field-searcher -->
                  <ng-container *ngIf="col?.hasSearch">
                    <app-field-searcher
                      [clearFilters]="clearFilters"
                      [customOperators]="col?.customOperators"
                      [type]="col?.type"
                      [enumValues]="col?.enumValues"
                      [enumName]="col?.enumName"
                      [fieldName]="col?.name"
                      [inputDirection]="col?.dir"
                      [noNumberSeparator]="col?.noNumberSeparator"
                      [defaultSearchValue]="col?.defaultSearchValue"
                      [defaultOperator]="col?.defaultOperator"
                      [dateDefaultValue]="col?.dateDefaultValue"
                      [isRequired]="col?.isRequired"
                      [defaultDateType]="col?.defaultDateType"
                      (comparisonObject)="getComparisonObject($event)"
                    >
                    </app-field-searcher>
                  </ng-container>

                  <ng-container *ngIf="!col?.hasSearch">
                    <div class="search-box"></div>
                  </ng-container>

                  <!--#endregion -->
                </div>
              </div>
            </th>
            }
            <th
              [attr.order]="99"
              [attr.name]="'action'"
              *ngIf="config?.showOperationColumn"
              [ngClass]="{
                'sticky-th':
                  !input_loading && !input_isEmpty && innerWidth > 1024
              }"
            ></th>
          </tr>
        </thead>

        <!-- body -->

        <tbody>
          <!--#region preloading -->
          <ng-container *ngIf="input_loading">
            <tr *ngFor="let item of preloadingRowCount">
              <td style="width: 1px">
                <div class="preloading"></div>
              </td>
              @for(col of config?.tableColumns ; track $index;){
              <td [attr.colspan]="col?.colSpan || 1" *ngIf="!col?.isHide">
                <div class="preloading"></div>
              </td>
              }
              <td style="width: 1px">
                <div class="preloading"></div>
              </td>
            </tr>
          </ng-container>
          <!--#endregion -->

          <!------ Table Content -------->
          <ng-content *ngIf="!input_hasError"></ng-content>

          <!--#region empty -->
          <ng-container
            *ngIf="!input_loading && input_isEmpty && !input_hasError"
          >
            <tr>
              <td colspan="100">
                <p
                  class="tw-text-center tw-text-gray-700 dark:tw-text-gray-200 tw-my-5 tw-text-xl tw-dir-rtl ltr:tw-dir-ltr"
                >
                  {{ "common.empty" | translate }}
                </p>
              </td>
            </tr>
          </ng-container>
          <!--#endregion -->

          <!--#region error -->
          <ng-container *ngIf="input_hasError">
            <tr>
              <td colspan="100">
                <p
                  class="tw-text-center tw-text-gray-600 dark:tw-text-gray-300 tw-my-5 tw-text-xl tw-flex-center"
                >
                  {{ "messages.noConnectionToServer" | translate }}
                  <i
                    class="mdi mdi-alert-circle-outline mdi-24px tw-mx-1 tw-text-gray-600 dark:tw-text-gray-300"
                  ></i>
                </p>
              </td>
            </tr>
          </ng-container>
          <!--#endregion -->
        </tbody>
      </table>
    </div>
  </div>

  <!--#region pagination -->
  <app-paginator
    [ignoreDisableBtn]="ignoreDisableBtn"
    [clearFilters]="clearFilters"
    *ngIf="!config?.hidePagination"
    [pageIndex]="config?.paginationModel?.pageIndex"
    [totalCount]="config?.paginationModel?.totalCount"
    [totalPages]="config?.paginationModel?.totalPages"
    [hasNextPage]="config?.paginationModel?.hasNextPage"
    [hasPreviousPage]="config?.paginationModel?.hasPreviousPage"
    [hidePageSize]="config?.hidePageSize"
    [pageSizes]="config?.pageSizes"
    (pageNumber)="emitPageNumber($event)"
    [loading]="input_loading"
    (pageSize)="emitPageSize($event)"
    (deselectAll)="emitSelectAll($event)"
  ></app-paginator>
  <!--#endregion -->
</div>
